const uatProperties = {
  profile: "uat",
  apiBaseUrl: "https://uat.massbusinesszone.com",
  msil: {
    // CRITICAL SECURITY FIX: clientId is OK to expose (OAuth client IDs are public)
    clientId: "6hq8mnbcjemqrhohdsln7qp5j4",
    redirectUrl: "https://uat.massbusinesszone.com/AdminHome/dashboard",
    federatedLoginUrl: "https://uat.massbusinesszone.com/api/auth/federated-login",
    exchangeUrl: "https://uat.massbusinesszone.com/api/auth/exchange-token",
    sessionUrl: "https://uat.massbusinesszone.com/api/auth/session",
    revenueUrl: "https://uat.massbusinesszone.com/api/v1/admin/revenue",
    // CRITICAL SECURITY FIX: Removed apiKey - now handled securely by backend
    // Backend endpoint: /api/auth/logout-federation
    // apiKey is stored in backend application.properties and never exposed to frontend
  },
};

export default uatProperties;

